import { clsx } from "clsx";
import React, { useRef, useState } from "react";

import "./ProgressBar.scss";

const FULL = 100;

export const ProgressBar = (props: {
  buffered: number;
  current: number;
  onSeek: (value: number) => void;
}): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [isActive, setIsActive] = useState<boolean>(false);

  /**
   * The event is triggered for the wrapper and all children.
   * We cannot rely on the event.target element width to get
   * percentage because it's different for total, buffered, current
   * etc.  So instead we use the wrapper ref, assuming that the
   * children are positioned inside and strictly within this wrapper.
   */
  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    const em = ref.current;

    if (em) {
      const rect = em.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const pc = Math.round(x * FULL / rect.width);
      setIsActive(true);
      props.onSeek(pc);
    }
  };

  const classes = clsx(["progressBar", { "progressBar--active": isActive }]);

  return (
    <div
      className={classes}
      onClick={onClick}
      ref={ref}
    >
      <div className="total bar"></div>

      <div className="buffered bar" style={{
        width: `${props.buffered}%`,
      }}></div>

      <div className="current bar" style={{
        width: `${props.current}%`,
      }}></div>

      <div
        className="bullet"
        style={{
          left: `${props.current}%`
        }}
      ></div>
    </div>
  );
};
